function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import EventEmitter from 'eventemitter3';
import { removeObserver } from '@netless/forge-room';
export const TOOLBAR_KEYS = {
  tool: 'tool',
  fontSize: 'fontSize',
  fontFamily: 'fontFamily',
  strokeColor: 'strokeColor',
  fillColor: 'fillColor',
  strokeWidth: 'strokeWidth',
  dashArray: 'dashArray'
};
export class ToolbarModel extends EventEmitter {
  get currentTool() {
    return this.root.get(TOOLBAR_KEYS.tool);
  }
  set currentTool(value) {
    this.root.set(TOOLBAR_KEYS.tool, value);
  }
  get fontSize() {
    return this.root.get(TOOLBAR_KEYS.fontSize);
  }
  set fontSize(value) {
    this.root.set(TOOLBAR_KEYS.fontSize, value);
  }
  get dashArray() {
    return this.root.get(TOOLBAR_KEYS.dashArray);
  }
  set dashArray(value) {
    this.root.set(TOOLBAR_KEYS.dashArray, value);
  }
  get fontFamily() {
    return this.root.get(TOOLBAR_KEYS.fontFamily);
  }
  set fontFamily(value) {
    this.root.set(TOOLBAR_KEYS.fontFamily, value);
  }
  get strokeColor() {
    return this.root.get(TOOLBAR_KEYS.strokeColor);
  }
  set strokeColor(value) {
    this.root.set(TOOLBAR_KEYS.strokeColor, value);
  }
  get fillColor() {
    return this.root.get(TOOLBAR_KEYS.fillColor);
  }
  set fillColor(value) {
    this.root.set(TOOLBAR_KEYS.fillColor, value);
  }
  get strokeWidth() {
    return this.root.get(TOOLBAR_KEYS.strokeWidth);
  }
  set strokeWidth(value) {
    this.root.set(TOOLBAR_KEYS.strokeWidth, value);
  }
  constructor(root, defaultStyle) {
    super();
    _defineProperty(this, "root", void 0);
    _defineProperty(this, "handleRootUpdate", evt => {
      for (const [key, value] of evt.changes.keys.entries()) {
        if (Object.keys(TOOLBAR_KEYS).indexOf(key) >= 0 && (value.action === 'add' || value.action === 'update')) {
          this.emit('update', {
            tool: this.currentTool,
            fontSize: this.fontSize,
            fontFamily: this.fontFamily,
            strokeColor: this.strokeColor,
            fillColor: this.fillColor,
            strokeWidth: this.strokeWidth,
            dashArray: this.dashArray
          });
        }
      }
    });
    this.root = root;
    this.root.observe(this.handleRootUpdate);
    Object.keys(defaultStyle).forEach(key => {
      if (!this.root.has(key) || this.root.get(key) === undefined) {
        this.root.set(key, defaultStyle[key]);
      }
    });
  }
  dispose() {
    removeObserver(this.root, this.handleRootUpdate);
    this.removeAllListeners();
  }
}